import { Box, Card, CardContent, Typography } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, FlexRow, QuickTipButton, TokenAmount } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'

import { EthBlock } from '../../Components'
import { parseBigNumberOptional } from '../../parseBigNumber'

interface RefundedCurrentBidEventProps {
  event: XyoWorldMinterEvents.RefundedCurrentBid
}

const RefundedCurrentBidEventCard: React.FC<RefundedCurrentBidEventProps> = ({ event }) => {
  const quadkey = Quadkey.fromBase10String(event.args.id.toString())
  return (
    <Box margin={1}>
      <Card>
        <CardContent>
          <FlexRow flexWrap="wrap">
            <Box padding={1}>
              <EthAccountButton variant="outlined" address={EthAddress.fromString(event.args.to)} />
            </Box>
            <Typography variant="body1">received a refund of</Typography>
            <TokenAmount amount={parseBigNumberOptional(event.args.amount, 0)} />
            <Typography variant="body1">from previous bid on geotoken #{quadkey.toBase4HashLabel()}</Typography>
            <Typography variant="body1">&nbsp;on block</Typography>
            <EthBlock block={event.blockNumber} />
            <QuickTipButton title="Smart Contract Bug">
              Due to a bug in the XyoWorldMinter Smart Contract, this event always emits 0x0 for the &apos;to&apos; address. This page uses the
              address from the previous bid to render the data has is should be emitted.
            </QuickTipButton>
          </FlexRow>
        </CardContent>
      </Card>
    </Box>
  )
}

export default RefundedCurrentBidEventCard
